import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=36e6dd06&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=ts"
export * from "./Preloader.vue?vue&type=script&lang=ts"
import style0 from "./Preloader.vue?vue&type=style&index=0&id=36e6dd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6dd06",
  null
  
)

export default component.exports